import isEmail from 'validator/lib/isEmail';

const validateAgentFieldsHasErrors = (agent) => {
  if (agent.firstName === '') {
    return true;
  }
  if (agent.lastName === '') {
    return true;
  }
  if (!isEmail(agent.email)) {
    return true;
  }
  if (agent.phoneNumber.Home === '') {
    return true;
  }
  if (agent.agencyId === 0) {
    return true;
  }
  return false;
}

export default validateAgentFieldsHasErrors;
